import moment from 'moment'
import React from 'react';
import { FilePdfOutlined , FileOutlined, CloudOutlined, BarChartOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';


export function hasErrors  (fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export function getStatusColor(status){
	switch(status.toLowerCase()){
		case 'en progreso':
            return 'blue';
		case 'Listo':
		case 'completado':
			return 'green';
		case 'error':
            return 'red';
		case 'expirado':
		case 'no encontrado':
			return 'yellow'
		default:
			return 'blue';
	}
}

export function renderStatusCell(statusRequest, totalFiles) {
    if (!statusRequest || !Array.isArray(statusRequest)) {
        return null;
    }

    const status = statusRequest[0] || '';
    const message = statusRequest[1] || '';
    const messageIndicatesNoInfo = message.toLowerCase().includes('no se encontr');
    const completedWithNoFiles = status.toLowerCase() === 'completado' && totalFiles === 0;
    const noInfoFound = messageIndicatesNoInfo || completedWithNoFiles;
    const displayStatus = noInfoFound ? 'Completado' : status;

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Tag color={getStatusColor(displayStatus)}>
                <Tooltip title={message}>
                    <span>{displayStatus}</span>
                </Tooltip>
            </Tag>
            {
                noInfoFound &&
                <span style={{fontSize: '12px'}}>{'No se encontró información'}</span>
            }
        </div>
    );
}

export function renderIconDownload(report){    
    let data;
    const props = {
            className: report.url === null ? 'gray-icon' : 'blue-icon',
            style: {fontSize: '20px', cursor:'pointer'},
            twoToneColor:'#1ec0ca'
        
    }
        switch(report.processType){
            case 'XmlReport':
                data = {
                    title: `Xml/Reporte - ${report.statusProcess}`,
                    Icon: <FileOutlined  twoToneColor={props.twoToneColor} className={props.className}  style={props.style} />
                };
            break;
            case 'PDF':
                data = {
                    title: `Pdf's - ${report.statusProcess}`,
                    Icon: <FilePdfOutlined twoToneColor={props.twoToneColor} className={props.className} style={props.style} />
                };     
            break;
            case 'MetadataReport':
                data = {
                    title: `Metadata/Reporte - ${report.statusProcess}`,
                    Icon: <FileOutlined twoToneColor={props.twoToneColor} className={props.className}  style={props.style} />
                };
            break;
            case 'GoogleDrive':
                data = {
                    title: `Google Drive`,
                    Icon: <CloudOutlined twoToneColor={props.twoToneColor} className={props.className} style={props.style}/>
                };
            break;
            default:
                data = {};
        }

    return data;
}


export function renderIconDashboard(row){   
    const statusRequest = row.processes[0].statusProcess;
    return {
        title:  statusRequest === 'Completado' ? 'Dashboard' : `Dashboard - ${statusRequest}`, 
        Icon: <BarChartOutlined className={statusRequest!== 'Completado' ? 'gray-icon' : 'blue-icon'} style={{ fontSize: '20px', cursor:'pointer' }}/>,                    
    };
}

export function downloadFile(link){
    let a = document.createElement('a');
    a.href = link;
    a.click();
}
export function toTitleCase(json){
    let str = JSON.stringify(json);
    return JSON.parse(str.replace(/\w\S*/g, function (txt) {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }));
}

export function getToken(){
    const sessionToken = sessionStorage.getItem("tokenExpiration");    
    return sessionToken ? JSON.parse(sessionToken).value : ''; 
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = error => reject(error);
    });
}

export function stringToQuantityWithCommas(value){
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getTaxPayer(taxpayerVolume,taxId){
    return taxpayerVolume.find(taxpayer => taxpayer.taxId === taxId);
}

export function checkIfVolumeIsBeingCalculated(startDate, updateDate) {
    let firstDate = moment(startDate);
    let lastDate = moment(updateDate);
    if(lastDate.diff(firstDate) !== 0 )
        return true;
    return false;   
}
export function didVolumeCalculated(volume,documentType){
    const amount = documentType==='0' ? volume.issuingVolumeMonthly : volume.receivingVolumeMonthly
    if(amount === undefined) return false
    return amount > 0;
}

export function validateVolume(volume, type, days,documentType){
    const amount = documentType==='0' ? volume.issuingVolumeMonthly : volume.receivingVolumeMonthly
    const maxVolume = type === '2' ? 2000000 : 200000;
    const maxDays = Math.round(maxVolume / amount) *30;
    return parseInt(days) <= maxDays;
}

export function diffDaysBetweenTwoDates(startDate, endDate) {
    let start = moment(startDate);
    let end = moment(endDate);
    return end.diff(start, "days");
}

export function formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
}

export function isPackageExpired(expiredDate) {
    const today = moment();   
    const end = moment(expiredDate,'DD/MM/YYYY'); 
    return today.isAfter(end);
}

export function formatNumberWithComma(number) {
    return number.toLocaleString('en-US', {maximumFractionDigits:2})
}

//helpers para componentes genéricos
export const getCopy = (array) => JSON.parse(JSON.stringify(array));

export const add = (data, array) => {
    let items = getCopy(array);
    items.push(data);
    return items;
};

/* Inmutable Array operations */
export const update = (data, arrayO) => {
    let array = getCopy(arrayO);
    let item = find(data.id, array); //obtenemos el item
    if(item) {
        let copy = getCopy(item);
        let index = array.findIndex(element=>{
            return element.id === copy.id;
        });
        if(index >-1) {
            let updated = {...copy, ...data, };
            array.splice(index, 1, updated);
        }
    }
    return array;
}

export const deleteItem = (id, array) => {
    return array.filter(element => element.id !== id);
}

export const find = (id, array) => {
    return array.find(function(item){
        return item.id === id;
    })
}

export const generic = (state, items, key) => {
    return {
        ...state,
        [key]: {
            ...state[key],
            items
        }
    };
}

export const isExplorerOrEdge = () => {
    let ua = window.navigator.userAgent;    
    let isIE = /MSIE|Trident/.test(ua);
    let isEdge = /Edge/.test(ua); 
    
    if ( isIE  || isEdge) 
        return true;
    return false;
}

export function formatMoney(amount){
    let formatter = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
      });
    
    if(isNaN(amount))
      return amount;
    return formatter.format(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getValueFromQueryString(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

export const addExtraHeadersIfIsExplorerorEdge = () => {
    if(isExplorerOrEdge()) {
        return {
            'Cache-Control': 'no-store, no-cache, must-revalidate',
            Pragma: 'no-cache',
            Expires: new Date('01.01.2000')
        }
    }

    return {};
}

export const getEnvironment = () => {
    switch(window.location.host){
        case 'efisco.test.sw.com.mx':
            return 'staging';
        case 'efisco.sw.com.mx':
            return 'production';
        default: //localhost
            return 'develop';
    }  
}

export function orderListByKey(data, key, order) {
    const compareValues = (key, order = "asc") => (elemA, elemB) => {
      if (!elemA.hasOwnProperty(key) || !elemB.hasOwnProperty(key)) return 0;
      const comparison = elemA[key].localeCompare(elemB[key]);
      return order === "desc" ? comparison * -1 : comparison;
    };
    return data.sort(compareValues(key, order));
  }